import "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridDetailRowProps,
  GridExpandChangeEvent,
  GridNoRecords
} from "@progress/kendo-react-grid";
import {
  checkCompanyType,
} from "../../utils/EllowUtils";
import { useState } from "react";
import { Resources } from "./interfaces";
import classnames from "classnames";
import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
import { Icon } from '@iconify/react';

const AllCompanies = (props: any) => {
  const [categories, setCategories] = useState<Resources[]>([]);
  const initialSort: Array<SortDescriptor> = [
    { field: "", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);
  const DetailComponent = (props: GridDetailRowProps) => {
    const data = props.dataItem.tags;
    if (data) {
      return (
        <Grid data={data}>
           <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
          <Column field="availability" title="Product ID" width="120px" />
          <Column field="availability_date" title="Product Name" />
          <Column field="availability_week" title="Unit Price" />
        </Grid>
      );
    }
    return (
      <div style={{ height: "50px", width: "100%" }}>
        <div style={{ position: "absolute", width: "100%" }}>
          <div className="k-loading-image" />
        </div>
      </div>
    );
  };

  const rowClick = (e: any) => {
      props.rowClick(e);
      
  };

  const getTableValues = () => {
    props.getTables();
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    event.dataItem.expanded = event.value;
    let candidateId = event.dataItem.candidateId;
    setCategories([...categories]);

    if (!event.value) {
      return;
    }
    setCategories(props.state.items);
  };

  return (
    <Grid
      data={props.state.items}
      onPageChange={props.pageChange}
      total={props.state.total}
      skip={props.state.skip}
      pageable={props.state.pageable}
      pageSize={props.state.pageSize}
      onRowClick={(e) => rowClick(e)}
      detail={DetailComponent}
      expandField="expanded"
      onExpandChange={expandChange}
      sortable={true}
      sort={sort}
      onSortChange={(e) => {
        setSort(e.sort);
        props.setSort(e.sort);
        props.applySort(e.sort);
      }}
    >
      <Column field="companyName" title="Company Name" cell={(props: GridCellProps) => companyName(props)} />
      {/* <Column field="name" title="Name" /> */}
          {/* <Column field="email" title="Email"/> */}
          <Column
        field="companyType"
        title="Job Type"
        cell={(props: GridCellProps) => companyType(props)}
      />
      <Column field="phoneNumber" title="Phone Number" />
      <Column
        field="dateOfReg"
        title="Date of Registration"
        cell={(props: GridCellProps) => dateOfReg(props)}
      />
      <Column field="status" title="Status" width="150px" cell={(props: GridCellProps) => statusChange(props)} />
    </Grid>
  );
};

export default AllCompanies;

const dateOfReg = (props: GridCellProps) => {
  let date = props.dataItem.dateOfReg
    ? new Date(parseInt(props.dataItem.dateOfReg)).toDateString()
    : "";
  return <td>{date}</td>;
};

const companyType = (props: GridCellProps) => {
  return <td>{checkCompanyType(props.dataItem.companyType)}</td>
};

const companyName = (props: GridCellProps) => {
    return (
        <td>
            <div className="userInfo">
                <figure>{props.dataItem && props.dataItem.companyName && props.dataItem.companyName[0]}{props.dataItem && props.dataItem.companyName && props.dataItem.companyName[1]}</figure>
                {props.dataItem.companyName}
            </div>
    </td>
)
}

const checkColour = (value:boolean) => {
    switch (value) {
        case true:
            return 'Green'
        case false:
            return 'Red'
 }
}

const statusChange = (props: GridCellProps) => { 
    
    return (
        <td>
            <div className={classnames(checkColour(props.dataItem.status) + " statusMessage")}>
                {props.dataItem.status ? 'Approved' : 'Rejected'}
            </div>
        </td>
    )
}